export const globalSeoDefaults = {
  title: "",
  description: "",
  keywords: "",
  author: "",
  canonical: "",
  favicon16: "",
  favicon32: "",
  // themeColor: "#2d378b",
  
  // Open Graph Meta Tags
  ogTitle: "",
  ogDescription: "",
  ogUrl: "",
  ogImage: "", // URL to image
  ogImageWidth: "1200", // Image width for OG
  ogImageHeight: "630", // Image height for OG
  ogSiteName: "",
  ogLocale: "de_DE",
  
  // Twitter Card Meta Tags
  twitterCard: "summary_large_image",
  twitterTitle: "",
  twitterDescription: "",
  
  // Schema.org Meta Tags
  schemaImage: "", // Same URL as ogImage unless specified otherwise
};
